import { render, staticRenderFns } from "./kota.vue?vue&type=template&id=6e0fbbdb"
import script from "./kota.vue?vue&type=script&lang=js"
export * from "./kota.vue?vue&type=script&lang=js"
import style0 from "./kota.vue?vue&type=style&index=0&id=6e0fbbdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports